import { useParams } from '@/js/libs/router';

import type { BroadcastRouteParams } from '../types.ts';

export const useRouteParams = () => useParams<BroadcastRouteParams>();
